import type { SetStateAction } from "react";
import { useRef, useState } from "react";
import { useOnUnmount } from "../useOnUnmount/useOnUnmount";

export function useStateIfMounted<T = unknown>(
  initValue: T,
): [T, (value: SetStateAction<T>) => void];
export function useStateIfMounted<T>(): [
  T | undefined,
  (value: SetStateAction<T | undefined>) => void,
];
export function useStateIfMounted<T>(
  initValue?: T,
): [T | undefined, (value: SetStateAction<T | undefined>) => void] {
  const [stateValue, setStateValue] = useState(initValue);
  const isMounted = useRef(true);

  useOnUnmount(() => {
    isMounted.current = false;
  });

  const setValue = (value: SetStateAction<T | undefined>): void => {
    if (isMounted.current) {
      setStateValue(value);
    }
  };

  return [stateValue, setValue];
}
